import { z } from 'zod';

export const createPayerSchema = <T extends z.ZodTypeAny>(accountSchema: T) =>
  z.object({
    accountIdentifiers: accountSchema,
    email: z.string().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    organisationName: z.string().nullable().optional(),
    phoneNumber: z.string().nullable().optional(),
    reference: z.string(),
  });
